import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormControl, FormGroup, UntypedFormGroup, Validators } from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
  selector: "name-ticket",
  templateUrl: "./name-ticket.component.html",
  styleUrls: ["./name-ticket.component.scss"],
})
export class NameTicketComponent implements OnInit ,OnChanges{
  @Input() category: string;
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;

  constructor() {}

  ngOnInit(): void {}
  onFileSelect(file:FileInput) {
    this.form.get("passport").setValue({
      name: file.file.name,
      content: file.base64,
    });
  }

  onFileRemove() {
    this.form.get("passport").reset();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }
  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }
  initiateForm() {
    this.form.addControl(
      "passport",
      new FormControl("", [Validators.required])
    );
    this.form.addControl("message", new FormControl("", ));
  }
  get message() {
    return this.form.get("message");
  }
  get passport() {
    return this.form.get("passport");
  }
}
